<template>
  <v-dialog v-model="dialog" overlay-opacity="0.75" persistent :max-width="width" :key="dialogKey">

    <v-card relative class="backgroundW py-3">
      <v-btn absolute class="" :style="$vuetify.rtl == true ? 'left: 5px' : 'right: 5px'" small fab
        color="grey lighten-1" text @click="closeDialog">
        <v-icon color="grey lighten-1">mdi-close</v-icon>
      </v-btn>
      <v-card-title class="subtitle-1 font-weight-bold">
        {{ $t('choose discount type') | capitalize }}
      </v-card-title>

      <v-col cols="10" class="d-block mt-2 ma-auto">
        <v-row align="center" justify="space-between">
          <v-col v-for="type in discountTypes" :key="type.id" cols="3" class="py-1">
            <v-btn depressed block :outlined="!(discount_type == type.id)" width="113px"
              :color="discount_type == type.id ? 'primary' : 'gray5'" @click="discount_type = type.id">
              <v-icon size="19">{{ type.icon }}</v-icon>
              {{ $t(type.name) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="10" class="d-block ma-auto" v-if="!couponsTab && discount_type != 4">
        <NumberPad :backValueMethod="setValue" :value="String(discount_value || '')"></NumberPad>
      </v-col>
      <v-col cols="10" class="d-block my-5 mb-10 ma-auto" v-if="couponsTab">
        <!-- <GenericInput type="select" :clearable="true" :dense="false" backgroundColor="white" :lookups="availCoupons"
          selected_label="coupon_code" paddingY="py-2 py-lg-0" paddingX="px-0" selected_prop="id" :value="coupon"
          :multi="false" @input="coupon = $event" label="select coupon" :isLoading="false" :hideDetails="true"
          :cols="[12, 12, 12]" icon="mdi-chevron-down" /> -->

        <GenericInput type="text" :dense="false" backgroundColor="white" selected_label="coupon_code"
          paddingY="py-2 py-lg-0" paddingX="px-0" selected_prop="id" :value="coupon_code" :multi="false"
          @input="coupon_code = $event" label="coupon" :isLoading="coupon_loading" :hideDetails="true"
          :cols="[12, 12, 12]" />
      </v-col>
      <v-col cols="10" class="d-block my-5 mb-10 ma-auto" v-if="discount_type == 4">
        <!-- Points Balance Display -->
        <div class="caption primary--text mb-3">
          {{ $t('available points') | capitalize }}:
          <span class="font-weight-bold">{{ customerPointsBalance }}</span>
          <v-tooltip bottom v-if="customerPointsBalance > 0">
            <template v-slot:activator="{ on, attrs }">
              <v-icon size="16" v-bind="attrs" v-on="on" class="ml-1">mdi-information</v-icon>
            </template>
            <span>{{ $t('points can be used to reduce the total price before VAT') }}</span>
          </v-tooltip>
        </div>

        <!-- Points Input -->
        <v-autocomplete v-if="validationMinPointsToRedeem" v-model="points_to_use"
          :items="convertToMultiples(customerPointsBalance, 10)" :label="$t('points to use')" outlined item-text="name"
          item-value="id" backgroundColor="white" />

        <!-- Warning if minimum not met -->
        <v-alert v-if="!validationMinPointsToRedeem" type="info" dense outlined class="mt-2">
          {{ $t('minimum bill value to use points') | capitalize }}:
          <span class="font-weight-bold">{{ minAmountToRedeemPoints | float }} {{ $t('sar') }}</span>
        </v-alert>
      </v-col>

      <v-col cols="10" class="d-block ma-auto pt-0">
        <v-row justify="space-between">
          <v-col cols="auto" class="pt-0">
            <v-btn :height="40" class="shadow-none" text plain @click="closeDialog" color="error" :loading="false"
              style="width: 100%; text-align: start">
              {{ $t('cancel') }}
            </v-btn>
          </v-col>
          <v-col cols="auto" class="pt-0">
            <v-btn :height="40" v-if="discount_type !== 3" :disabled="!(saveValid)" class="shadow-none" @click="save"
              min-width="120" color="success" :loading="false" style="width: 100%; text-align: start">
              {{ $t('save') }}</v-btn>

            <v-btn :height="40" v-if="discount_type == 3" :disabled="!(coupon_code)" class="shadow-none"
              @click="couponCodeSearch" min-width="120" color="secondary" :loading="coupon_loading"
              style="width: 100%; text-align: start">
              {{ $t('search') }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
</template>



<style scoped lang="scss"></style>



<script>
import NumberPad from '../NumberPad.vue';
import { createNamespacedHelpers } from "vuex";
import GenericInput from '../GenericInput.vue';
const { mapState } = createNamespacedHelpers("InvoiceStore");
export default {
  name: "DiscountModal",
  props: {
    width: { default: 610 },
    dialog: { default: false },
    coupons: { default: [] },
    setDiscount: { type: Function },
    returnCloseDialog: { type: Function },
  },
  mounted() {
    window.addEventListener("keydown", e => {
      if (e.key == 'Enter' && this.dialog && this.saveValid && this.discount_type !== 3) {
        this.save();
        this.dialogKey = this.dialogKey + 1
      }
      else if (e.key == 'Enter' && this.discount_type == 3 && this.coupon_code && this.customer_data.id) {
        this.couponCodeSearch();
      }
    });
  },
  computed: {
    ...mapState(["totalPriceWithVat", "totalPrice", "discount", "customer_data", "invoice"]),
    saveValid() {
      if (this.discount_type == 1 && Number(this.discount_value) >= this.totalPrice) {
        return false
      }
      if (this.discount_type == 2 && Number(this.discount_value) >= 100) {
        return false
      }
      if (this.discount_type == 3) {
        let coupon = this.coupons.find(coupon => coupon.id == this.coupon) || {}
        if (coupon.coupon_type == 1 && coupon.discount >= this.totalPrice) {
          return false
        } else if (coupon.coupon_type == 2 && coupon.discount >= 100) {
          return false
        } else {
          return true
        }
      }
      if (this.discount_type == 4) {
        return this.points_to_use > 0 && this.validationMinPointsToRedeem && this.customer_data.id
      }
      else {
        return true
      }
    },
    availCoupons() {
      return this.coupons
      // return this.coupons.filter(coupon => {
      //   let customer = coupon.customers_id.split(',').map(i => +i) || []
      //   if (customer.includes(this.customer_data.id)) {
      //     return coupon
      //   } else {
      //     if (coupon.for_customer == 0) {
      //       return coupon
      //     }
      //   }
      // })
    },
    selectedCoupon() {
      return this.coupons.find(coupon => coupon.id == this.coupon) || {}
    },
    minAmountToRedeemPoints() {
      return Number(this.$store.state.userData.settings?.min_amount_invoice || 0);
    },
    pricePerPoint() {
      return Number(this.$store.state.userData.settings?.points_count_sar_usage || 0);
    },
    validationMinPointsToRedeem() {
      return (this.totalPriceWithVat >= this.minAmountToRedeemPoints)
    },
    convertToMultiples() {
      return (dividend, divisor) => Array.from({ length: Math.floor(dividend / divisor) }, (_, i) => {
        let amount = (i + 1) * divisor
        return {
          id: amount,
          name: amount,
          disabled: (amount / this.pricePerPoint) > this.totalPrice,
        }
      });
    },
  },
  data: () => ({
    discount_value: 0,
    coupon_code: null,
    dialogKey: 1,
    discount_type: 2,
    coupon: 0,
    couponsTab: false,
    coupon_loading: false,
    points_to_use: 0,
    customerPointsBalance: 0,
    discountTypes: [
      {
        id: 1,
        name: 'value',
        icon: 'mdi-currency-usd'
      },
      {
        id: 2,
        name: 'percentage',
        icon: 'mdi-percent-outline'
      },
      {
        id: 3,
        name: 'coupon',
        icon: 'mdi-ticket-percent-outline'
      },
      {
        id: 4,
        name: 'points',
        icon: 'mdi-star-circle'
      },
    ]
  }),
  methods: {
    closeDialog() {
      this.returnCloseDialog();
      // this.couponsTab = false;
    },
    setValue(value) {
      this.discount_value = Number(value);
    },
    save() {
      let discountValue = this.discount_type == 4 ? this.points_to_use / this.pricePerPoint : this.discount_value;

      // Calculate discount before VAT and VAT amount when discount type is value (1)
      let discount_before_vat = 0;
      let discount_vat = 0;
      let distributionByRate = {};

      if (this.discount_type == 1 && discountValue > 0) {
        // Use ERP-style distribution across different tax rates
        const distribution = this.$global.DISTRIBUTE_DISCOUNT_BY_TAX_RATE(
          this.invoice,
          discountValue
        );
        discount_before_vat = distribution.totalDiscountNet;
        discount_vat = distribution.totalDiscountVat;
        distributionByRate = distribution.byRate;
        // Update discount value to be the amount before VAT
        discountValue = discount_before_vat;
      }

      var discount = {
        type: this.discount_type,
        value: discountValue,
        is_coupon: 0,
        coupon_id: 0,
        discount_amount: 0,
        percent_value: 0,
        coupon: {},
        points_used: this.discount_type == 4 ? this.points_to_use : 0,
        discount_before_vat: discount_before_vat,
        discount_vat: discount_vat,
        original_discount_value: this.discount_type == 1 ? this.discount_value : discountValue,
        distribution_by_rate: distributionByRate
      }
      console.log('------------------- discount: ', discount);
      this.setDiscount(discount);
      this.couponsTab = false;
      this.returnCloseDialog();
    },
    couponCodeSearch() {
      if (this.customer_data.id && this.coupon_code) {
        this.coupon_loading = true;
        this.$api.GET_METHOD(`check_coupon?coupon_code=${this.coupon_code}&customer_id=${this.customer_data.id}`).then((response) => {
          this.coupon_loading = false;
          if (response.check) {
            let discount = {
              type: 3,
              value: +response.data.coupon.discount,
              coupon_id: +response.data.coupon.coupon_id,
              is_coupon: 1,
              discount_amount: 0,
              percent_value: 0,
              coupon: {
                id: response.data.coupon.coupon_id || 1,
                coupon_code: this.coupon_code,
                discount_type: response.data.coupon.discount_type || 1,
                discount: +response.data.coupon.discount || 0,
                items: response.data.coupon.items || [],
              }
            }
            console.log('------------------- discount: ', discount);
            this.setDiscount(discount);
            this.couponsTab = false;
            this.returnCloseDialog();
          }
        });
      }

    },
    fetchCustomerPointsBalance() {
      if (this.customer_data.id) {
        this.$api.GET_METHOD(`customer_info/${this.customer_data.id}`).then(({ check, data: { data } }) => {
          if (check) {
            this.customerPointsBalance = Number(data?.wallet_points || 0);
          }
        });
      }
    },
  },

  watch: {
    'discount_type'() {
      // reset discount value
      this.discount.value = 0;

      if (this.discount_type == 3) {
        this.couponsTab = true;
      } else {
        this.couponsTab = false;
        this.coupon = null
      }
      if (this.discount_type == 4) {
        this.fetchCustomerPointsBalance();
      }
    },
    dialog() {
      this.coupon_code = null;
      // Use original_discount_value if available (for value discounts that were split by VAT)
      this.discount_value = this.discount.original_discount_value || this.discount.value;
      this.discount_type = this.discount.type || 1;
      this.points_to_use = 0;
      if (this.dialog && this.customer_data.id) {
        this.fetchCustomerPointsBalance();
      }
    },
    'customer_data.id'() {
      if (this.customer_data.id && this.discount_type == 4) {
        this.fetchCustomerPointsBalance();
      }
    }
  },
  components: {
    NumberPad,
    GenericInput
  }
};
</script>
